export default "//cdn.scentbird.com/assets/frontbird-site/images/suede_8bdf77.jpg";